<template>
    <div
        class="banner-button"
        :class="'count-' + renderButtons.length"
        v-if="renderButtons?.length > 0"
    >
        <a
            v-for="(button, index) in renderButtons"
            :key="button.link + '-' + index"
            :href="['callback', 'anchor'].includes(button.type) ? null : button.link"
            class="btn-item"
            :class="{ plain: button.plain }"
            rel="noopener noreferrer"
            :target="button.target || '_blank'"
            :aria-label="getButtonLabel(button)"
            @click="click(button, $event)"
            :style="getStyle(button)"
        >
            <span class="button-text" v-if="showText" v-html="getButtonLabel(button)"></span>
            <i :class="['iconfont', arrowIconPolyfill]" v-show="showArrow"></i>
        </a>
    </div>
</template>

<script>
import { getButtonHtmlStyle } from '@/common/utils/decode-html';
export default {
    emits: ['callback', 'scrollTo'],
    props: {
        size: {
            type: Number,
            default: 0
        },
        buttons: {
            type: Array,
            default: () => []
        },
        showArrow: {
            type: Boolean,
            default: false
        },
        showText: {
            type: Boolean,
            default: true
        },
        isV8: {
            type: Boolean,
            default: false
        },
        arrowIcon: {
            type: String,
            default: 'icon-arrow-up'
        }
    },
    computed: {
        renderButtons() {
            const buttons = [];
            this.buttons.forEach(item => {
                const text = this.getButtonLabel(item);
                if (text || (!this.showText && this.showArrow)) {
                    buttons.push(item);
                }
            });
            return buttons;
        },
        arrowIconPolyfill({ isV8 }) {
            return isV8 ? 'icon-arrow_06' : 'icon-arrow-up';
        }
    },
    methods: {
        getButtonLabel(button) {
            let text =
                button.label ||
                button.text ||
                (button.textOption &&
                    (button.textOption?.text || button.textOption?.html)) ||
                '';
            return text.replace(/<[^>]*>/g, '');
        },
        click(button, event) {
            //  If there is type field and not 'url' when type ， Instead callback ， For example, click the button to pop up the registration box
            if (button && button.type && button.type === 'callback') {
                this.$emit('callback', button);
            } else if (button && button.type && button.type === 'anchor') {
                event.preventDefault();
                this.$emit('scrollTo', button.anchor);
            }
        },
        getStyle(button) {
            let style = '';
            switch (button.plain) {
            case true:
                style = {
                    color: button.color,
                    borderColor: button.color,
                    backgroundColor: 'transparent'
                };
                break;
            case false:
                style = {
                    color: button.textColor,
                    backgroundColor: button.color,
                    borderColor: button.color
                };
                break;
            default:
                style = {
                    color: button.textColor,
                    backgroundColor: button.color,
                    borderColor: button.borderColor || button.color
                };
                break;
            }
            if (this.showText) {
                style = { ...style, ...getButtonHtmlStyle(button) };
            }
            return style;
        }
    }
};
</script>

<style lang="scss">
@import '../theme/media.scss';
@import '../theme/mixin.scss';
.banner-button {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .btn-item {
        position: relative;
        margin: 10px 5px 0 5px;
        padding: 0 20px;
        min-width: 190px;
        overflow: hidden;
        height: 40px;
        line-height: 38px;
        display: block;
        text-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        font-size: 12px;
        font-family: var(--mg-button-font);
        text-align: center;
        border: 1px solid;
        @include color-button();
        &:hover {
            &::after {
                content: '';
                background: rgba(25, 25, 25, 0.1);
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }
        .icon-arrow-up {
            transform: rotate(90deg);
            display: inline-block;
            font-size: 14px;
        }
        &.plain {
            border-color: var(--g-btn-background, #ffffff);
            color: var(--g-btn-background, #ffffff);
        }
    }
    .btn-item {
        cursor: pointer;
    }
}
</style>
